import { createMuiTheme } from '@material-ui/core/styles'

export const theme = createMuiTheme({
    shape: {
        borderRadius: 4
    },
    palette: {
        common: {
            black: '#000',
            white: '#fff'
        },
        primary: {
            main: '#136fcb',
            light: '#5ee7df',
            dark: '#00175A',
            contrastText: '#000'
        },
        secondary: {
            main: '#666666',
            light: '#77ffbb',
            dark: '#00a05d',
            contrastText: '#fff'
        },
        error: {
            light: '#e57373',
            main: '#a4a4a4', //'#d82a34',
            dark: '#d32f2f',
            contrastText: '#44a1ec' //'#fff'
        },
        success: {
            light: '#81c784',
            main: '#7ed321',
            dark: '#388e3c',
            contrastText: '#fff'
        },
        info: {
            light: '#64b5f6',
            main: '#2196f3',
            dark: '#1976d2',
            contrastText: '#fff'
        },
        warning: {
            light: '#ffb74d',
            main: '#ff9800',
            dark: '#f57c00',
            contrastText: '#fff'
        },
        grey: {
            '50': '#fafafa',
            '100': '#f5f5f5',
            '200': '#eeeeee',
            '300': '#e0e0e0',
            '400': '#bdbdbd',
            '500': '#9e9e9e',
            '600': '#757575',
            '700': '#616161',
            '800': '#424242',
            '900': '#212121',
            'A100': '#d5d5d5',
            'A200': '#aaaaaa',
            'A400': '#303030',
            'A700': '#616161'
        },
        text: {
            primary: '#54565a',
            secondary: '#1E2256',
            disabled: '#9e9e9e',
            hint: '#9e9e9e'
        },
        divider: '#d2d2d2',
        background: {
            paper: '#ffffff',
            default: '#f2f2f2',
        },
        action: {
            active: '#757575',
            hover: '#eaeaea',
            hoverOpacity: 0.08,
            selected: '#dbdbdb',
            disabled: '#bcbcbc',
            disabledBackground: '#e0e0e0'
        }
    },
    typography: {
        htmlFontSize: 16,
        fontFamily: "'Benton Sans', Roboto, Helvetica, Arial, sans-serif",
        fontSize: 14,
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeightMedium: 500,
        fontWeightBold: 700,
        h1: {
            fontWeight: 400,
            fontSize: '6rem',
            lineHeight: 1,
            letterSpacing: '0em'
        },
        h2: {
            fontWeight: 400,
            fontSize: '3.5rem',
            lineHeight: 1,
            letterSpacing: '0em'
        },
        h3: {
            fontFamily: 'Guardian Egyp',
            fontWeight: 400,
            fontSize: '3rem',
            lineHeight: 1.2,
            letterSpacing: '0em'
        },
        h4: {
            fontWeight: 500,
            fontSize: '2.125rem',
            lineHeight: 1.17,
            letterSpacing: '0em'
        },
        h5: {
            fontWeight: 500,
            fontSize: '1.5rem',
            lineHeight: 1.33,
            letterSpacing: '0em'
        },
        h6: {
            fontWeight: 500,
            fontSize: '1.25rem',
            lineHeight: 1.2,
            letterSpacing: '0em'
        },
        subtitle1: {
            fontWeight: 400,
            fontSize: '1rem',
            lineHeight: 1.75,
            letterSpacing: '0.00938em'
        },
        subtitle2: {
            fontWeight: 500,
            fontSize: '0.875rem',
            lineHeight: 1.57,
            letterSpacing: '0.00714em'
        },
        body1: {
            fontWeight: 400,
            fontSize: '1.0rem',
            lineHeight: 1.5,
            letterSpacing: '0.00938em'
        },
        body2: {
            fontWeight: 400,
            fontSize: '0.875rem',
            lineHeight: 1.43,
            letterSpacing: "0.01071em"
        },
        button: {
            fontWeight: 500,
            fontSize: '1.1rem',
            lineHeight: 1.1,
            letterSpacing: '-0.5',
            textTransform: 'none'
        },
        caption: {
            fontWeight: 400,
            fontSize: '0.75rem',
            lineHeight: 1.66,
            letterSpacing: '0.03333em'
        },
        overline: {
            fontWeight: 400,
            fontSize: '0.75rem',
            lineHeight: 2.66,
            letterSpacing: '0.08333em'
        }
    }
})
